
export const ORDERS_TABLE_CONSTANTS = {

    ROW_HEIGHT: 73, 
    HEADER_HEIGHT: 56, 
    PAGINATION_HEIGHT: 64, 
    SEARCH_BAR_HEIGHT: 80, 
    PADDING_BUFFER: 20, 
    MIN_ROWS: 1, 
    
    RESIZE_DEBOUNCE_DELAY: 300, 
    INITIAL_CALCULATION_DELAY: 100, 
    
    SEARCH_PLACEHOLDER: 'Search Orders...',
    NO_ORDERS_MESSAGE: 'No orders found',
    NO_USER_SELECTED_MESSAGE: 'Select a user to view order history',
    
    SHOWING_TEXT: 'Showing',
    TO_TEXT: 'to',
    OF_TEXT: 'of',
    ORDERS_TEXT: 'orders'
  } as const;